import handleClick from '../../../../../../utils/handleClick';
import computeClassName from '../../../../../../utils/computeClassName';
import dropdownConstants  from '../constants';
import CCFormDropdownOpenCloseControlIcon from './_Icon';
import CCFormDropdownOpenCloseControlText from './_Text';

const constants = Object.freeze({
  CLASSNAME_BASE: 'transition-cc-colors duration-200 ease-linear relative appearance-none w-full inline-flex items-center focus:outline-none focus-visible:outline-none ring-inset',
  CLASSNAME_DROPDOWN_IS_LTR: {
    true: {
      CLASSNAME_DROPDOWN_SIZE: Object.fromEntries(
        new Map([
          [dropdownConstants.SIZE_XSMALL, 'pl-3'],
          [dropdownConstants.SIZE_SMALL, 'pl-4'],
          [dropdownConstants.SIZE_MEDIUM, 'pl-4'],
          [dropdownConstants.SIZE_LARGE, 'pl-4']
        ])
      )
    },
    false: {
      CLASSNAME_DROPDOWN_SIZE: Object.fromEntries(
        new Map([
          [dropdownConstants.SIZE_XSMALL, 'pr-3'],
          [dropdownConstants.SIZE_SMALL, 'pr-4'],
          [dropdownConstants.SIZE_MEDIUM, 'pr-4'],
          [dropdownConstants.SIZE_LARGE, 'pr-4']
        ])
      )
    }
  },

  CLASSNAME_DROPDOWN_IS_DISABLED: {
    true: {
      DROPDOWN_HAS_ERROR: {
        true: 'ring-2 ring-cc-alert bg-cc-white',
        false: 'ring-1 ring-cc-gray-40 bg-cc-gray-05'
      }
    },
    false: {
      DROPDOWN_HAS_ERROR: {
        true: 'ring-2 ring-cc-alert bg-cc-white',
        false: 'ring-1 ring-cc-gray-40 bg-cc-white hover:ring-cc-accent focus:ring-cc-accent'
      }
    }
  },

  CLASSNAME_DROPDOWN_IS_OPENED: {
    true: 'rounded-t-lg z-20',
    false: 'rounded-lg'
  },

  CLASSNAME_SHOW_POINTER: {
    true: 'cursor-pointer',
    false: 'cursor-auto pointer-events-none',
  },

  CLASSNAME_TEXT_DROPDOWN_IS_LTR: {
    true: 'order-0 flex-grow text-left',
    false: 'order-1 flex-grow text-right'
  },

  CLASSNAME_ICON_DROPDOWN_IS_LTR: {
    true: 'order-1',
    false: 'order-0'
  },

});

function getComputedClassName(propsClassName, dropdownIsLTR, dropdownSize, dropdownIsOpened, dropdownIsDisabled, dropdownHasError, showPointer) {
  return computeClassName(propsClassName, `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_DROPDOWN_IS_LTR[dropdownIsLTR].CLASSNAME_DROPDOWN_SIZE[dropdownSize]} ${constants.CLASSNAME_DROPDOWN_IS_OPENED[dropdownIsOpened]}  ${constants.CLASSNAME_DROPDOWN_IS_DISABLED[dropdownIsDisabled].DROPDOWN_HAS_ERROR[dropdownHasError]} ${constants.CLASSNAME_SHOW_POINTER[showPointer]}`)
}

function getComputedOpenCloseTextClassName(className, dropdownIsLTR) {
  return computeClassName(className, `${constants.CLASSNAME_TEXT_DROPDOWN_IS_LTR[dropdownIsLTR]}`);
}

function getComputedOpenCloseIconClassName(className, dropdownIsLTR) {
  return computeClassName(className, `${constants.CLASSNAME_ICON_DROPDOWN_IS_LTR[dropdownIsLTR]}`);
}

export default function CCFormDropdownOpenCloseControl(
  {
    dropdownSize,
    dropdownIsOpened,
    dropdownIsDisabled,
    dropdownIsProcessingInProgress,
    dropdownHasError,
    dropdownOpenTitle,
    dropdownOpenFn,
    dropdownOpenFnArgs,
    dropdownCloseTitle,
    dropdownCloseFn,
    dropdownCloseFnArgs,
    dropdownSelectedOptions,
    dropdownIsLTR,
    dropdownPlaceholderText,
    dropdownMultipleSelectionText,
    dropdownReplaceCountInMultipleSelectionText,
    dropdownCountKeyword,
    dropdownMultipleSelectionTextShownIfCountAbove,
    dropdownSelectedOptionSeparator,
    dropdownOptionKeyLabel,
    className = ''
  }) {
  let dynamicProps = {};
  if (!dropdownIsDisabled && !dropdownIsProcessingInProgress) {
    let computedTitle, computedClickFn, computedClickFnArgs;
    if (dropdownIsOpened) {
      computedTitle = dropdownCloseTitle;
      computedClickFn = dropdownCloseFn;
      computedClickFnArgs = dropdownCloseFnArgs;
    }
    else {
      computedTitle = dropdownOpenTitle;
      computedClickFn = dropdownOpenFn;
      computedClickFnArgs = dropdownOpenFnArgs;
    }
    dynamicProps['aria-label'] = computedTitle;
    dynamicProps['onClick'] = handleClick(computedClickFn, computedClickFnArgs);
  }
  else {
    dynamicProps['disabled'] = true;
    dynamicProps['aria-disabled'] = true;
  }

  const computedClassName = getComputedClassName(className, dropdownIsLTR, dropdownSize, dropdownIsOpened, dropdownIsDisabled, dropdownHasError, !dropdownIsDisabled && !dropdownIsProcessingInProgress);
  const computedOpenCloseTextClassName = getComputedOpenCloseTextClassName('', dropdownIsLTR);
  const computedOpenCloseIconClassName = getComputedOpenCloseIconClassName('', dropdownIsLTR);

  return (
    <button className={computedClassName}
            type="button"
            {...dynamicProps}>
      <CCFormDropdownOpenCloseControlText dropdownPlaceholderText={dropdownPlaceholderText}
                                          dropdownMultipleSelectionText={dropdownMultipleSelectionText}
                                          dropdownReplaceCountInMultipleSelectionText={dropdownReplaceCountInMultipleSelectionText}
                                          dropdownCountKeyword={dropdownCountKeyword}
                                          dropdownMultipleSelectionTextShownIfCountAbove={dropdownMultipleSelectionTextShownIfCountAbove}
                                          dropdownSelectedOptionSeparator={dropdownSelectedOptionSeparator}
                                          dropdownIsDisabled={dropdownIsDisabled}
                                          dropdownSelectedOptions={dropdownSelectedOptions}
                                          dropdownOptionKeyLabel={dropdownOptionKeyLabel}
                                          className={computedOpenCloseTextClassName}/>
      <CCFormDropdownOpenCloseControlIcon dropdownSize={dropdownSize}
                                          dropdownIsOpened={dropdownIsOpened}
                                          dropdownIsProcessingInProgress={dropdownIsProcessingInProgress}
                                          dropdownIsLTR={dropdownIsLTR}
                                          className={computedOpenCloseIconClassName}/>
      {
        dropdownIsOpened &&
        <span aria-hidden="true"
              className="absolute left-0 bottom-0 block w-full h-px bg-cc-gray-05"/>
      }
    </button>
  );

}
